<template>
  <div class="credential-wrap">
    <back-button :tag="false" />
    <van-grid :column-num="2" :border="false">
      <van-grid-item @click="goDetail(1)">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-1.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-1.png"
            alt="竞赛达人"
          />
        </picture>
        <van-button
          v-if="Object.keys(jingsaidaren).length > 0"
          class="item-btn"
          color="linear-gradient(to bottom, #9df7d5, #002aa2)"
          round
          :disabled="Number(jingsaidaren.target) > Number(jingsaidaren.num)"
          >{{
            Number(jingsaidaren.target) > Number(jingsaidaren.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        >
      </van-grid-item>
      <van-grid-item @click="goDetail(2)">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-2.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-2.png"
            alt="十级学者"
          />
        </picture>
        <van-button
          v-if="Object.keys(shijixuezhe).length > 0"
          class="item-btn"
          color="linear-gradient(to bottom, #9df7d5, #002aa2)"
          round
          :disabled="Number(shijixuezhe.target) > Number(shijixuezhe.num)"
          >{{
            Number(shijixuezhe.target) > Number(shijixuezhe.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        >
      </van-grid-item>
      <van-grid-item @click="goDetail(3)">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-3.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-3.png"
            alt="答题大王"
          />
        </picture>
        <van-button
          v-if="Object.keys(datidawang).length > 0"
          class="item-btn"
          color="linear-gradient(to bottom, #9df7d5, #002aa2)"
          round
          :disabled="Number(datidawang.target) > Number(datidawang.num)"
          >{{
            Number(datidawang.target) > Number(datidawang.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        >
      </van-grid-item>
      <van-grid-item @click="goDetail(4)">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-4.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-4.png"
            alt="知识猎手"
          />
        </picture>
        <van-button
          v-if="Object.keys(zhishilieshou).length > 0"
          class="item-btn"
          color="linear-gradient(to bottom, #9df7d5, #002aa2)"
          round
          :disabled="Number(zhishilieshou.target) > Number(zhishilieshou.num)"
          >{{
            Number(zhishilieshou.target) > Number(zhishilieshou.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        >
      </van-grid-item>
      <van-grid-item @click="goDetail(5)">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-5.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-5.png"
            alt="常胜将军"
          />
        </picture>
        <van-button
          v-if="Object.keys(changshengjiangjiu).length > 0"
          class="item-btn"
          color="linear-gradient(to bottom, #9df7d5, #002aa2)"
          round
          :disabled="
            Number(changshengjiangjiu.target) > Number(changshengjiangjiu.num)
          "
          >{{
            Number(changshengjiangjiu.target) > Number(changshengjiangjiu.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        >
      </van-grid-item>
      <van-grid-item @click="goDetail(6)">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-6.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-6.png"
            alt="学习标兵"
          />
        </picture>
        <van-button
          v-if="Object.keys(xuexibiaobing).length > 0"
          class="item-btn"
          color="linear-gradient(to bottom, #9df7d5, #002aa2)"
          round
          :disabled="Number(xuexibiaobing.target) > Number(xuexibiaobing.num)"
          >{{
            Number(xuexibiaobing.target) > Number(xuexibiaobing.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        >
      </van-grid-item>
    </van-grid>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
  data() {
    return {
      xuexibiaobing: {},
      changshengjiangjiu: {},
      datidawang: {},
      jingsaidaren: {},
      shijixuezhe: {},
      zhishilieshou: {},
    };
  },
  methods: {
    async getList() {
      try {
        const res = await this.$axios.post(`/Statis/getMedal`);
        const {
          xuexibiaobing,
          changshengjiangjiu,
          datidawang,
          jingsaidaren,
          shijixuezhe,
          zhishilieshou,
        } = res?.data ?? {};
        this.xuexibiaobing = xuexibiaobing;
        this.changshengjiangjiu = changshengjiangjiu;
        this.datidawang = datidawang;
        this.jingsaidaren = jingsaidaren;
        this.shijixuezhe = shijixuezhe;
        this.zhishilieshou = zhishilieshou;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.msg || "获取证书错误",
          duration: 2000,
        });
        console.log(error);
      } finally {
        this.$toast.clear();
      }
    },
    goDetail(type) {
      switch (type) {
        case 1:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.jingsaidaren.num}&target=${this.jingsaidaren.target}&date=${this.jingsaidaren.date}`
          );
          break;
        case 2:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.shijixuezhe.num}&target=${this.shijixuezhe.target}&date=${this.shijixuezhe.date}`
          );
          break;
        case 3:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.datidawang.num}&target=${this.datidawang.target}&date=${this.datidawang.date}`
          );
          break;
        case 4:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.zhishilieshou.num}&target=${this.zhishilieshou.target}&date=${this.zhishilieshou.date}`
          );
          break;
        case 5:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.changshengjiangjiu.num}&target=${this.changshengjiangjiu.target}&date=${this.changshengjiangjiu.date}`
          );
          break;
        case 6:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.xuexibiaobing.num}&target=${this.xuexibiaobing.target}&date=${this.xuexibiaobing.date}`
          );
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.credential-wrap {
  @include plain-bg;

  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 0 22px 28px;
  overflow: hidden;

  .van-grid {
    .van-grid-item {
      margin-top: 24px;
      cursor: pointer;

      .item-btn {
        width: 105px;
        height: 29px;
        margin-top: 8px;
      }
    }

    ::v-deep .van-grid-item__content {
      justify-content: flex-start;
      padding: 0;
      background: transparent;
    }

    .icon {
      width: 127px;
      height: 158px;
      vertical-align: middle;
    }
  }
}
</style>
